module.exports = __webpack_public_path__ + "static/media/empty.1f176811.png";